export const getCssVariableValue = (key, element = document.body) =>
  getComputedStyle(element).getPropertyValue(key)?.trim();

export default { getCssVariableValue };
